import { get, post } from '../config/$ajax.js'

// 名片展示
export const showBusinessCard = (data = {}, params = {submitType: 'json', isNeedLoading: true}) => {
  return get('/companyBusinessInfo/showBusinessCard', data, params);
}

// 合作意向展示
export const showCooperationIntention = (data = {}, params = {submitType: 'json', isNeedLoading: true}) => {
  return get('/companyBusinessInfo/showCooperationIntention', data, params);
}

// 修改联系人信息
export const editContactInfo = (data = {}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/companyBusinessInfo/editContactInfo', data, params);
}

// 名片编辑
export const editBusinessCard = (data={}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/companyBusinessInfo/editBusinessCard', data, params);
}

// 分销商-名片编辑
export const editDmsBusinessCard = (data={}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/dms/editBusinessCard', data, params);
}

// 合作意向编辑
export const editCooperationIntention = (data={}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/companyBusinessInfo/editCooperationIntention', data, params);
}
// 商品列表(查看自己分销小店的)
export const distributionShopItemList = (data = {}, params = {}) => {
  return post('/distribution/shop/item/list', data, {appJson: true, submitType: 'json', ...params})
}

// 商品置顶操作,取消置顶或者置顶
export const distributionShopItemTop = (data = {}, params = {}) => {
  return get('/distribution/shop/item/top', data, params);
}

// 商品置顶移动
export const distributionShopItemTopMove = (data = {}, params = {}) => {
  return get('/distribution/shop/item/top/move', data, params);
}

// 商品中心导入
export const importBaseItems = (data ={},  params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/item/base/importBaseItems', data, params)
}
// 分销小店: 供销商-批量修改分销价接口
export const batchEditDistributionPrice = (data = {}, params = {}) => {
  return post('/distribution/shop/opt/batchEditDistributionPrice', data, {appJson: true, submitType: 'json'})
}

// 分销小店: 供销商-修改商品运营数据
export const batchEditDistributionShopItem = (data = {}, params = {}) => {
    return post('/distribution/shop/item/modify/operate/data', data, {appJson: true, submitType: 'json'})
}

// 小店商品详情
export const distributionShopItemDetail = (data = {}, params = {}) => {
  return get('/distribution/shop/item/detail', data, params)
}

// 小店商品详情
export const supplierPromotionShopItem = (data = {}, params = {}) => {
  return get('/dms/supplierPromotionShopItem', data, params)
}

// 供销商商品推广 - 供销商商品详情
export const sharePromotionShopItem = (data = {}, params = {}) => {
  return get('/share/supplierPromotionShopItem', data, params)
}

export const sharePromotionShopCompanyInfo = (data = {}, params = { submitType: "json", isNeedLoading: true }) => {
  return get('/share/supplierPromotionShopCompanyInfo', data, params);
};

// 判断分销商品是否存在ERP商品关联关系
export const hasErpItemInfo = (data = {}, params = { isNeedLoading: true }) => {
  return get('/distribution/shop/opt/hasErpItemInfo', data, params);
};

// 导出运营数据
export const exportOperateData = (data = {}, params = { isNeedLoading: true }) => {
  return post('/distribution/shop/item/exportOperateData', data, {appJson: true, submitType: 'json', ...params})
};


// 导出商品运营数据结果查询
export const exportOperateDataResult = (data = {}, params = { isNeedLoading: true }) => {
    return post('/distribution/shop/item/queryExportOperateDataResult', data, {appJson: true, submitType: 'json', ...params})
};

/**
 * 导入运营数据
 */
export const uploadOperateRequest = (data = {}, params = { isNeedLoading: true }) => {
    return post('/distribution/shop/item/importItemOperateData', data, { submitType: 'form-data', headers: { 'Content-Type': 'multipart/form-data' }, ...params });
};


//------小店装饰--start----
// 获取小店装饰配置
export const queryShopSettingConf = (data = {}, params = {}) => {
  return get('/scmCompanyConf/queryShopSettingConf', data, params)
}
// 保存小店装饰配置
export const updateShopSettingConf = (data = {}, params = {}) => {
  return post('/scmCompanyConf/updateShopSettingConf', data, {appJson: true, submitType: 'json'})
}
export const defaultRecoverSet = (data = {}, params = {}) => {
  return get('/scmCompanyConf/queryShopDefaultSetting', data, params)
}
//------小店装饰--end----
// 修改微信信息（微信号+二维码）
export const editWxInfo = (data = {}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/companyBusinessInfo/editWxInfo', data, params);
}

export const getItemReceiveAddressApi = (data={},params={}) => {
  return get('/item/base/getItemReceiveAddress', data,params)
}